<template>
<div class="card"
    :class="isMiddle ? 'middle-card' : ''"
    @click="viewPlayback(item)">
    <div class="lesson-img">
        <img v-show="showLessonImage" :src="item.imageUrl" @error="showLessonImage = false">
        <div class="period"> {{ item.periodStr }}</div>
    </div>
    <div class="info">
        <div>
            <img class="avatar" :src="item.teacherAvatar || defaultAvatar" alt="👱">
            <span class="family-name">{{ item.teacherFamilyName }}老师</span>
            <span class="type-tag"
                :class="getTypeTagClass(item.type)">{{ item.typeStr }}</span>
        </div>
        <!-- type === 3 为答疑课 -->
        <!--<p v-if="item.type !== 3"
            :class="item.reportGenerated === 2 ? 'report-ready' : 'report-disable'"
            @click.stop="viewReport(item)">
              课后报告<span>></span>
        </p>-->
    </div>
</div>
</template>

<script>
import defaultAvatar from '../../../assets/images/user/user-info.png';

export default {
    props: {
        item: {
            type: Object,
            default: () => {}
        },
        isMiddle: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            defaultAvatar,
            showLessonImage: true
        };
    },
    methods: {
        // 跳转回放详情
        viewPlayback(playback) {
            const { lessonId, coursePlanId, sessionId, type } = playback;
            this.$router.push({ name: 'videoDetail@course',
                query: {
                    lessonId, coursePlanId, sessionId, type
                } });
        },
        // 确定所需的css class；
        getTypeTagClass(type) {
            switch (type) {
            case Enums.LessonType.FREE_LESSON:
                return 'type-tag-free';
            case Enums.LessonType.FORMAL_LESSON:
                return 'type-tag-formal';
            case Enums.LessonType.QA_LESSON:
                return 'type-tag-qa';
            default:
                return '';
            }
        },
        // 跳转“课后报告”
        viewReport(playback) {
            const VIDEO_NOT_GENERATED = 1;
            if (playback.reportGenerated === VIDEO_NOT_GENERATED) {
                return;
            }
            const { lessonId, coursePlanId, type } = playback;
            this.$router.push({
                name: 'report@course',
                query: { lessonId, coursePlanId, type }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.card {
    width: 290px;
    height: 207px;
    background-color: #fff;
    margin: 7.5px 0;
    box-shadow: 0 0 8px 0 #cdd0d4;
    border-radius: 2px;
    cursor: pointer;

    &:hover {
        box-shadow: 0 0 20px 0 #cdd0d4;
    }

    .lesson-img {
        width: 100%;
        height: 163px;
        background: #f2f2f2;
        position: relative;

        img {
            width: 100%;
            height: 163px;
        }
    }

    .period {
        background-image: linear-gradient(-180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 100%);
        height: 30px;
        line-height: 30px;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        font-size: 12px;
        color: #fff;
        padding-left: 6px;
    }

    .info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 44px;
        padding: 0 6px;

        .avatar {
            width: 24px;
            height: 24px;
            border-radius: 50%;
            vertical-align: middle;
        }

        .family-name {
            padding: 0 6px;
        }

        .type-tag {
            line-height: 1.5;
            font-size: 12px;
            display: inline-block;
            padding: 0 4px;
            background: rgba(145, 113, 221, 0.1);
            border-radius: 0 8px;
        }

        .type-tag-formal {
            background: rgba(45, 189, 114, 0.1);
            color: #2dbd72;
        }

        .type-tag-qa {
            background: rgba(255, 132, 83, 0.1);
            color: #ff8453;
        }

        .type-tag-free {
            background: rgba(145, 113, 221, 0.1);
            color: #9171dd;
        }

        .report-ready {
            color: $B03;
            cursor: pointer;

            &:hover {
                color: darken($B03, 15%);
            }
        }

        .report-disable {
            color: $A05;
            cursor: text;
        }
    }
}

.middle-card {
    margin: 7.5px 25px;
}
</style>



// WEBPACK FOOTER //
// src/views/index/components/CourseVideoCard.vue